module.exports = __webpack_public_path__ + "img/35.3d12b86e.jpg";